export default __webpack_public_path__ + "static/media/doctor_icon.fbc7e9fe.svg";